import config from "../config";
import jwt from "jwt-simple";

const getLocalStorageUser = () =>
{
  return config.local_storage.user;
};

const getLocalStorageAuth = () =>
{
  return config.local_storage.auth;
};

const getUrlApi = () =>
{
  return config.api.url;
};

const getApiKey = () =>
{
  return config.api.api_key;
};

const getJwtKey = () =>
{
  return config.jwt.key;
};

const getAuthToken = () =>
{
  return JSON.parse(
    jwt.decode(
      localStorage.getItem(jwt.encode(getLocalStorageAuth(), getJwtKey())),
      getJwtKey(),
    ),
  ).auth_token;
};

const getRequestSign = (email, password) =>
{
  return new Request(getUrlApi() + `/collection-point-passport-admin/sign`, {
    method: "POST",
    body: JSON.stringify({ email: email, password: password }),
    headers: new Headers({
      "Content-Type": "application/json",
      "x-api-key": getApiKey(),
    }),
  });
};

const getHeadersFormData = () =>
{
  return {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    "x-api-key": getApiKey(),
    "x-token": "Bearer " + getAuthToken(),
  };
};

const getCurrentUser = () =>
{
  if (localStorage.getItem(jwt.encode(getLocalStorageUser(), getJwtKey())) !== null)
    return JSON.parse(
      jwt.decode(
        localStorage.getItem(jwt.encode(getLocalStorageUser(), getJwtKey())),
        getJwtKey()
      )
    );
  else
    return null;
};

const setCurrentUser = (user) =>
{
  localStorage.setItem(
    jwt.encode(getLocalStorageUser(), getJwtKey()),
    jwt.encode(JSON.stringify(user), getJwtKey())
  );
};

const setCurrentAuth = (auth) =>
{
  localStorage.setItem(
    jwt.encode(getLocalStorageAuth(), getJwtKey()),
    jwt.encode(JSON.stringify(auth), getJwtKey())
  );
};

const clearLocalStorage = () =>
{
  localStorage.removeItem(jwt.encode(getLocalStorageUser(), getJwtKey()));
  localStorage.removeItem(jwt.encode(getLocalStorageAuth(), getJwtKey()));
};

export {
  getUrlApi,
  getRequestSign,
  getHeadersFormData,
  getCurrentUser,
  setCurrentUser,
  setCurrentAuth,
  clearLocalStorage
};
